const LIST_GRADE_VEHICLE = [
  {
    key: '',
    value: '',
    label: 'Grade',
  },
  {
    key: '0',
    value: 'A',
    label: 'A',
  },
  {
    key: '1',
    value: 'B',
    label: 'B',
  },
  {
    key: '2',
    value: 'C',
    label: 'C',
  },
  {
    key: '3',
    value: 'D',
    label: 'D',
  },
  {
    key: '4',
    value: 'E',
    label: 'E',
  },
]

export default LIST_GRADE_VEHICLE